<template>
  <component :is="layout"></component>
</template>
<script>
  import { timeFormatExclusive } from '@/index/shared/filters';
  import { setIdle, setOverlayStatus, state } from '@/shared/components/player/store';
  import UiTrackBar from '@/shared/components/track-bar/index.vue';
  import UiPlayerFullscreenBtn from '@/shared/components/player/components/controls/components/fullscreen/index.vue';
  import UiPlayerTogglePlay from '@/shared/components/player/components/controls/components/toggle-play/index.vue';
  import UiPlayerVolume from '@/shared/components/player/components/controls/components/volume/index.vue';
  import { OverlayStatus } from '@/shared/components/player/enums';
  import UiUpsellButton from '@/shared/components/upsell-button/index.vue';
  import DefaultLayout from './layouts/default.vue';
  import EmbeddedLayout from './layouts/embedded.vue';

  export default {
    components: {
      UiPlayerFullscreenBtn,
      UiPlayerTogglePlay,
      UiPlayerVolume,
      UiTrackBar,
      UiUpsellButton,
    },
    filters: {
      timeFormatExclusive,
    },
    props: {
      freeWheelPlayer: Object,
      isAdvertPlayerActive: Boolean,
      product: Object,
      isEmbedded: Boolean,
    },
    data() {
      return {
        adCount: 0,
        adIndex: 0,
        currentTime: 0,
        playheadTime: 0,
        totalDuration: 0,
        duration: 0,
        state,
      };
    },
    computed: {
      layout() {
        if (this.isEmbedded) {
          return EmbeddedLayout;
        }

        return DefaultLayout;
      },
      timeLeft() {
        return Math.round(this.duration - this.currentTime);
      },
      totalTimeLeft() {
        return Math.round(this.totalDuration - this.playheadTime);
      },
      progress() {
        return (this.currentTime / this.duration) * 100;
      },
      showCounter() {
        return this.adIndex > 0 && this.adCount > 0;
      },
      isVisible() {
        return this.isInteraction;
      },
      isInteraction() {
        return state.overlayStatus === OverlayStatus.INTERACTION;
      },
    },
    watch: {
      freeWheelPlayer() {
        if (!this.freeWheelPlayer) {
          return;
        }

        this.freeWheelPlayer.on('onSlotStarted', ({ adCount }) => {
          this.adCount = adCount;
          setOverlayStatus(OverlayStatus.INTERACTION);
          setIdle();
          this.totalDuration = this.freeWheelPlayer.slot.getTotalDuration();
        });
        this.freeWheelPlayer.on('loadedmetadata', ({ duration }) => {
          this.duration = duration;
        });
        this.freeWheelPlayer.on('timeupdate', ({ currentTime, adIndex }) => {
          this.adIndex = adIndex;
          this.currentTime = Math.round(currentTime);
          this.playheadTime = this.freeWheelPlayer.slot.getPlayheadTime();
        });
      },
      'state.mute': function (mute) {
        if (!this.freeWheelPlayer) {
          return;
        }

        if (mute) {
          this.freeWheelPlayer.mute();
        } else {
          this.freeWheelPlayer.unMute();
        }
      },
      'state.volume': function (volume) {
        this.freeWheelPlayer?.setVolume(volume);
      },
      'state.playerStatus': function (state) {
        this.freeWheelPlayer?.onPlayerStatusChange(state);
      },
    },
    created() {
      window.addEventListener('keydown', this.handleKeyboard);
    },
    beforeDestroy() {
      window.removeEventListener('keydown', this.handleKeyboard);
    },
    methods: {
      onClick() {
        if (!state.isLinearAdPlaying) {
          return;
        }

        const {
          preroll,
          midroll,
          postroll,
        } = this.freeWheelPlayer.slots;
        const allPlayableAds = [...preroll, ...midroll, ...postroll];
        const totalCount = allPlayableAds.length;

        this.$stats.adClick({
          type: this.freeWheelPlayer.getCurrentSlotType(),
          position: this.adIndex,
          breakPosition: this.adIndex,
          breakTotalAds: this.adCount,
          totalCount,
        }, this.product);
      },
      stopPropagation(event) {
        event.stopPropagation();
      },
      handleMouseMove() {
        setOverlayStatus(OverlayStatus.INTERACTION);
        setIdle();
      },
    },
  };
</script>
